import { createSlice } from "@reduxjs/toolkit";
import {
  deleteUser,
  getMemberByMainMember,
  getOnlineUser,
  getUser,
  undoDeleteUser,
} from "./user.api";

const usersSlice = createSlice({
  name: "users",
  initialState: {
    users: [],
    members: [],
    onlineUsers: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    // GET Banner FILTER WISE DATA
    builder.addCase(getUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getUser.fulfilled, (state, action) => {
      state.loading = false;
      state.users = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getUser.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getMemberByMainMember.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getMemberByMainMember.fulfilled, (state, action) => {
      state.loading = false;
      state.members = action.payload;
      state.dataLimit = action.payload.data.meta.limit;
      state.currentPage = action.payload.data.meta.page;
      state.totalPages = action.payload.data.meta.totalPages;
      state.totalData = action.payload.data.meta.totalCount;
    });
    builder.addCase(getMemberByMainMember.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(getOnlineUser.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOnlineUser.fulfilled, (state, action) => {
      state.loading = false;
      state.onlineUsers = action.payload.data; // The array of online users
      state.dataLimit = action.payload.pagination.limit;
      state.currentPage = action.payload.pagination.currentPage;
      state.totalPages = action.payload.pagination.totalPages;
      state.totalData = action.payload.pagination.total; // Note: 'total' not 'totalCount'
    });
    builder.addCase(getOnlineUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(deleteUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteUser.fulfilled, (state, action) => {
      const deletedId = action.payload.id; // Use the deleted user ID from the payload

      if (state.users.data) {
        state.users.data = state.users.data.filter(
          (user) => user._id !== deletedId
        );
      }
      if (state.members.data) {
        state.members.data = state.members.data.data.filter(
          (member) => member._id !== deletedId
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteUser.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (Array.isArray(state.users.data)) {
        state.users.data = state.users.data.filter(
          (user) => user._id !== undodeletedId
        );
      } else {
        console.error("state.users.data is not an array:", state.users.data);
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = usersSlice.actions;
export default usersSlice.reducer;
